'use client';
import React from 'react';
import { FileCode2 } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import Image from 'next/image';

const FeatureCard = ({ title, description, icon }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={`relative  cursor-pointer hover:shadow-sm hover:shadow-cyan-500
      bg-gradient-to-br from-[#1FBCCB1F] via-[#020C0D] to-transparent
      transition-all duration-200 rounded-xl flex items-start
      justify-start border overflow-hidden border-gray-600 p-8
      ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
    >
      <Image
        alt="grid pattern"
        src="/assets/union.svg"
        width={500}
        height={500}
        className="absolute left-0 top-0"
      />

      <div className="relative z-10 space-y-6">
        {/* Icon Container */}
        <div className="relative w-12 h-12 flex items-center justify-center">
          <div className="absolute inset-0 rounded-xl bg-[radial-gradient(circle_at_center,#696F6F_0%,#3E4746_100%)]"></div>
          {icon ? (
            <div
              dangerouslySetInnerHTML={{ __html: icon }}
              className="absolute left-0 top-0 text-white z-10 scale-75"
            />
          ) : (
            <FileCode2 className="w-6 h-6 text-white relative z-10" />
          )}
        </div>

        {/* Content */}
        <h3 className="text-lg font-medium bg-clip-text text-transparent bg-gradient-to-b from-[#FFFFFF] to-[#999999]">
          {title}
        </h3>
        <p className="text-gray-300 text-base leading-relaxed max-w-full whitespace-pre-wrap break-words">
          {description}
        </p>
      </div>
    </div>
  );
};

const FeatureGrid = ({ cards }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto px-4 lg:px-0 py-12">
      {cards.map((card, index) => (
        <FeatureCard
          key={index}
          title={card.title}
          description={card.description}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default FeatureGrid;
